import React from "react";

interface IArrowProps {
  className?: string;
  strokeClassName?: string;
}

const Arrow = ({
  className = "",
  strokeClassName = "stroke-black fill-black",
}: IArrowProps) => (
  <svg
    className={className}
    style={{ width: "9px", height: "11px" }}
    viewBox="0 0 9 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={strokeClassName}
      d="M8.11265 4.00598L4.31023 0.204102L0.507812 4.00598L1.30266 4.80082L3.74254 2.3604V10.3621H4.87788V2.3604L7.31776 4.80082L8.11265 4.00598Z"
    />
  </svg>
);

export default Arrow;
